/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable react/no-unknown-property */
import { Logo, SectionContainer } from "@silversea-ssc/ui-components-react";
import React from "react";
import * as styles from "./BrandLogosFooter.module.scss";
const Royal_Caribbean_Group_logo =
  "/brand-logos/Royal_Caribbean_Group_logo.svg";
const Royal_Caribbean_logo = "/brand-logos/Royal_Caribbean_logo2.svg";
const Celebrity_Cruises_logo = "/brand-logos/Celebrity_Cruises_logo.svg";

const BrandLogosFooter = () => {
  return (
    <SectionContainer
      backgroundColor="transparent"
      wrapperClassName={styles.wrapper}
    >
      <div className={styles.logoBigWithRow}>
        <a
          href="https://www.royalcaribbeangroup.com/"
          target="_blank"
          rel="noreferrer"
          className={styles.logoBigContainer}
        >
          <img
            // @ts-ignore
            fetchpriority="low"
            src={Royal_Caribbean_Group_logo}
            alt="Royal Caribbean Group"
            className={styles.logoBig}
            loading="lazy"
            width={180}
            height={66}
          />
        </a>
      </div>
      <ul className={styles.logosRow}>
        <li className={styles.royal}>
          <a
            href="https://www.royalcaribbean.com/"
            target="_blank"
            rel="noreferrer"
          >
            <img
              // @ts-ignore
              fetchpriority="low"
              src={Royal_Caribbean_logo}
              alt="Royal Caribbean"
              className={styles.logo}
              loading="lazy"
              width={85}
              height={34}
            />
          </a>
        </li>
        <li className={styles.celebrity}>
          <a
            href="https://www.celebritycruises.com/"
            target="_blank"
            rel="noreferrer"
          >
            <img
              // @ts-ignore
              fetchpriority="low"
              src={Celebrity_Cruises_logo}
              alt="Celebrity Cuises"
              className={styles.logo}
              loading="lazy"
              width={126}
              height={28}
            />
          </a>
        </li>
        <li>
          <a href="https://www.silversea.com/" title="Silversea Cruises">
            <Logo color="white" width={135} mobileWidth={106} />
          </a>
        </li>
      </ul>
    </SectionContainer>
  );
};

export default BrandLogosFooter;
